import _ from "lodash";

export class Dictionary<TKey extends string | number | symbol, TValue> {
    private map: Record<TKey, TValue>;

    constructor(initialMap: Record<TKey, TValue>) {
        this.map = initialMap;
    }

    GetKeys(): TKey[] {
        return Object.keys(this.map) as TKey[];
    }

    GetKeyByValues(targetValues: TValue): TKey | undefined {
        for (const [key, values] of Object.entries(this.map)) {
            if (_.isEqual(values as TValue, targetValues)) {
                return key as TKey;
            }
        }
        return undefined;
    }

    GetValues(key: TKey): TValue | undefined {
        return this.map[key];
    }

    GetAllValues(): Record<TKey, TValue> {
        return this.map;
    }
}
